import { mapState } from "vuex";

const PAN_SPEED = 40;
const ZOOM_SPEED = 0.2;

export default {
  data() {
    return {
      instance: null,
    }
  },
  methods: {
    zoom(direction, e) {
      let transform = this.instance.getTransform();
      let scale = 1;
      switch (direction) {
        case "in":
          scale += ZOOM_SPEED;
          break;
        case "out":
          scale -= ZOOM_SPEED;
          break;
      }

      this.instance.smoothZoom(transform.x, transform.y, scale);
    },
    initPanzoom(panzoomInstance) {
      this.instance = panzoomInstance;
    },
    pan(direction) {
      let transform = this.instance.getTransform();
      let x = transform.x;
      let y = transform.y;

      switch (direction) {
        case "ArrowLeft":
          x += PAN_SPEED;
          break;
        case "ArrowRight":
          x -= PAN_SPEED;
          break;
        case "ArrowUp":
          y += PAN_SPEED;
          break;
        case "ArrowDown":
          y -= PAN_SPEED;
          break;
      }
      this.instance.smoothMoveTo(x, y);
    },

    // Resets position to fit background image to viewport
    resetPosition() {
      this.instance.moveTo(0, 0);
      this.instance.zoomAbs(0, 0, 1);
    },
  },
}